import BrightcoveLivestream from './BrightcoveLiveStream'

const RootsTechBrightcoveVideoProvider = `
  ${BrightcoveLivestream}
  fragment RootsTechBrightcoveVideoProvider on RootsTechBrightcoveVideoProvider {
    accountId
    liveStream {
      ...BrightcoveLivestream
    }
    playerId
    providerType
    videoId
  }
`
export default RootsTechBrightcoveVideoProvider
